import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthLayout } from '../../layouts/AuthLayout';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/Form/Input';
import { Checkbox } from '../../components/Form/Checkbox';
import { authService } from '../../services/auth.service';

export const LoginPage: React.FC<{ onLoginSuccess?: () => void }> = ({ onLoginSuccess }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      await authService.login({ email, password });
      onLoginSuccess?.();
      navigate('/');
    } catch (err: any) {
      console.error('Login error:', err);
      // API client returns { message, error, statusCode } or { error: { message } }
      const errorMessage = err?.message || err?.error?.message || 'Invalid email or password';
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (

    <AuthLayout>
      <div className="bg-[#F6F5F3] min-h-screen w-full flex items-center justify-center px-4 relative">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <h1 className="text-neutral-900">Sign in - Admin Page</h1>
          </div>

          {error && (
            <div 
              role="alert"
              className="mb-4 p-3 bg-error-50 border border-error-200 rounded-lg text-error-700 text-sm"
            >
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
          <Input
            label="Email"
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <Input
            label="Password"
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <div className="flex items-center justify-between">
            <Checkbox
              label="Remember for 30 days"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <Link to="/forgot-password" className="text-[#404040] hover:text-[#333333]" style={{
              fontFamily: 'Oxygen',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: '21px'
            }}>
              Forgot password
            </Link>
          </div>

          <Button
            type="submit"
            variant="primary"
            size="lg"
            isLoading={isLoading}
            className="w-full"
          >
            Sign in
          </Button>
          </form>

          <p className="text-center text-neutral-600 text-sm mt-6">
            Demo user: admin@ministryofwine.com / Password123!
          </p>
        </div>
        
        <div className="absolute bottom-4 left-6 text-neutral-900 text-sm">
          © Ministry of Wine 2026
        </div>
      </div>
    </AuthLayout>
  );
};

export default LoginPage;
